export const materials = [
    {
        id: 1,
        name: "ԼԱԲՈՐԱՏՈՐ ԱՇԽԱՏԱՆՔՆԵՐ (7-ՐԴ ԴԱՍԱՐԱՆ)",
        info: "Դիտել",
        file: "../../files/physics/materials/1.pdf",
        menuItemId: 3
    },
    {
        id: 2,
        name: "ԼԱԲՈՐԱՏՈՐ ԱՇԽԱՏԱՆՔՆԵՐ (8-ՐԴ ԴԱՍԱՐԱՆ)",
        info: "Դիտել",
        file: "../../files/physics/materials/2.pdf",
        menuItemId: 3
    },
    {
        id: 3,
        name: "ԼԱԲՈՐԱՏՈՐ ԱՇԽԱՏԱՆՔՆԵՐ (9-ՐԴ ԴԱՍԱՐԱՆ)",
        info: "Դիտել",
        file: "../../files/physics/materials/3.pdf",
        menuItemId: 3
    },
    {
        id: 4,
        name: "ՈՒՍՈՒՄՆԱԿԱՆ ՆՅՈՒԹԵՐ (8-ՐԴ ԴԱՍԱՐԱՆ)",
        info: "Դիտել",
        file: "../../files/physics/materials/4.pdf",
        menuItemId: 3
    },
    {
        id: 5,
        name: "Լաբորատոր սարքավորումների կիրառումը ուսումնական գործընթացում ուսուցչի ձեռնարկ ",
        info: "Դիտել",
        file: "../../files/physics/materials/5.pdf",
        menuItemId: 3
    },
    {
        id: 6,
        name: "Greenhouse effect",
        info: "Դիտել",
        file: "../../files/physics/materials/6.pdf",
        menuItemId: 3
    },
    {
        id: 7,
        name: "ՀՊՄՀ արտադասարանային արվեստի ուսուցիչների վերապատրաստում։",
        info: "Դիտել",
        file: "../../files/physics/materials/7.pdf",
        menuItemId: 3
    },
    {
        id: 8,
        name: "ՏԵՍԱԿԱՆ ՆՅՈՒԹԵՐ",
        info: "Դիտել",
        file: "../../files/physics/materials/8.pdf",
        menuItemId: 3
    },

];

